import React, { useState, useRef, useEffect } from 'react';
import Axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import defaultLogo from './logo.png';
import fLogo from './logofooter.png';

const NewInvoice = ({ logout, initialData, clearSharedData }) => {
  const [logo, setLogo] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState({
    companyTitle: 'AURORA CREATIVES',
    invoiceNo: "",
    issueDate: new Date().toISOString().split('T')[0],
    dueDate: new Date().toISOString().split('T')[0],
    clientName: "Mr. XYZ",
    company: "XYZ OF COMPANIES",
    address: "Building 110, King's Road, London, SW3 4TX",
    companyFooter: 'defaultLogo',
    directorName: "Name",
    directorTitle: "Designation", // Add this
    signature: '',                   // Add this to store the signature image
    items: [{ desc: "Service name 1", rate: 100, qty: 1 }],
    membershipType: "None",
    discount: 0,
    discountNote: "Platinum Gold Membership Discount",
    vatRate: 15,
    transactions: [{ date: new Date().toISOString().split('T')[0], method: "Bank Transfer", amount: 0 }], 
    status: "Partial",
    paidStatus: "",
    currency: "BDT",
    currencySymbol: "TK"
  });

  const [subtotal, setSubtotal] = useState(0);
  const [vatAmount, setVatAmount] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const invoiceRef = useRef();

  // Place this inside your NewInvoice component
// 1. Update the initial state to be safe


// 2. Add this EFFECT to handle the data coming from History
useEffect(() => {
  if (initialData) {
    const safeData = {
      ...initialData,
      issueDate: initialData.issueDate ? String(initialData.issueDate).split('T')[0] : new Date().toISOString().split('T')[0],
      dueDate: initialData.dueDate ? String(initialData.dueDate).split('T')[0] : new Date().toISOString().split('T')[0],
      items: Array.isArray(initialData.items) ? initialData.items : [],
      transactions: Array.isArray(initialData.transactions) ? initialData.transactions : [],
      // Ensure signature is explicitly mapped if coming from History DB fields
      signature: initialData.signature || initialData.signature_image || null 
    };
    setFormData(safeData);
    
    // If your NewInvoice stores the logo in a separate state
    if (initialData.logo) setLogo(initialData.logo);
  }
}, [initialData]);



  useEffect(() => {
    const fetchNextInvoice = async () => {
      const userId = localStorage.getItem("userId");
      if (userId && !initialData) {
        try {
          const res = await Axios.get(`http://localhost:3006/api/next-invoice?user_id=${userId}`);
          setFormData(prev => ({ ...prev, invoiceNo: res.data.nextInvoiceNo }));
        } catch (err) {
          console.error("Failed to fetch next invoice number", err);
        }
      }
    };
    fetchNextInvoice();
  }, [initialData]);

  useEffect(() => {
  if (initialData) {
    setFormData(prev => ({
      ...prev,           // Use 'prev' instead of 'formData'
      ...initialData,
      items: Array.isArray(initialData.items) ? initialData.items : [],
      transactions: Array.isArray(initialData.transactions) ? initialData.transactions : []
    }));
    clearSharedData();
  }
}, [initialData, clearSharedData]); // formData is no longer needed here

  useEffect(() => {
    // FIX: Safely access items and transactions with fallback empty arrays
    const items = formData.items || [];
    const transactions = formData.transactions || [];

    const total = items.reduce((acc, item) => acc + (Number(item.rate || 0) * Number(item.qty || 0)), 0);
    const vat = (total - Number(formData.discount || 0)) * (Number(formData.vatRate || 0) / 100);
    const paid = transactions.reduce((acc, t) => acc + Number(t.amount || 0), 0);
    
    const finalAmount = (total - Number(formData.discount || 0)) + vat;
    const balance = finalAmount - paid;

    setSubtotal(total);
    setVatAmount(vat);
    setTotalPaid(paid);

    const isPaid = balance <= 0 && total > 0;
    
    setFormData(prev => ({
      ...prev,
      status: isPaid ? "Paid" : "Unpaid",
      paidStatus: isPaid 
        ? `Paid in Full - Total Amount ${prev.currencySymbol} ${finalAmount.toLocaleString()}/- settled.`
        : `Payment Pending - Balance ${prev.currencySymbol} ${balance.toLocaleString()}/- due.`
    }));
  }, [formData.items, formData.discount, formData.vatRate, formData.transactions, formData.currencySymbol]);

  const handleCurrencyChange = (e) => {
    const val = e.target.value;
    let symbol = "TK";
    if (val === "USD") symbol = "$";
    if (val === "AUD") symbol = "AUD$";
    if (val === "CAD") symbol = "CAD$";
    if (val === "GBP") symbol = "£";
    if (val === "EUR") symbol = "€";
    setFormData({ ...formData, currency: val, currencySymbol: symbol });
  };

  const handleMembershipChange = (e) => {
    const type = e.target.value;
    let disc = 0;
    let note = "";
    if (type === "Platinum Titanium Membership") { disc = 5000; note = "Platinum Titanium Membership"; }
    if (type === "Platinum Gold Membership") { disc = 4000; note = "Platinum Gold Membership"; }
    else if (type === "Platinum Silver Membership") { disc = 3000; note = "Platinum Silver Membership"; }
    else if (type === "Signature Membership") { disc = 2000; note = "Signature Membership"; }
    else if (type === "Classic Membership") { disc = 1000; note = "Classic Membership"; }
    setFormData({ ...formData, membershipType: type, discount: disc, discountNote: note });
  };

  const handleLogoUpload = async (e) => {
  const file = e.target.files[0];
  if (file) {
    // 1. (Optional) Show an instant local preview
    const reader = new FileReader();
    reader.onloadend = () => setLogo(reader.result);
    reader.readAsDataURL(file);

    // 2. Upload to the local server
    const formDataPayload = new FormData();
    formDataPayload.append('logo', file);

    try {
      const response = await Axios.post('http://localhost:3006/api/upload-logo', formDataPayload);
      
      // 3. Save the permanent URL in your main form state
      setFormData(prev => ({ 
        ...prev, 
        companyFooter: response.data.url 
      }));
      console.log("Logo saved to local directory!");
    } catch (error) {
      console.error("Upload failed", error);
    }
  }
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: (name === 'vatRate' || name === 'discount') ? Number(value) : value });
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...(formData.items || [])];
    updatedItems[index][field] = field === 'desc' ? value : Number(value);
    setFormData({ ...formData, items: updatedItems });
  };

  const handleTxChange = (index, field, value) => {
    const updatedTx = [...(formData.transactions || [])];
    updatedTx[index][field] = field === 'amount' ? Number(value) : value;
    setFormData({ ...formData, transactions: updatedTx });
  };

  const addItem = () => setFormData({ ...formData, items: [...(formData.items || []), { desc: "", rate: 0, qty: 1 }] });
  const addTransaction = () => setFormData({ ...formData, transactions: [...(formData.transactions || []), { date: new Date().toISOString().split('T')[0], method: "", amount: 0 }] });
  const removeItem = (index) => setFormData({ ...formData, items: (formData.items || []).filter((_, i) => i !== index) });
  const removeTransaction = (index) => setFormData({ ...formData, transactions: (formData.transactions || []).filter((_, i) => i !== index) });

  const saveToDatabase = async (dbStatus = 'draft') => {
    setIsSaving(true);
    try {
      const response = await Axios.post("http://localhost:3006/api/save", {
        user_id: localStorage.getItem("userId"),
        ...formData,
        subtotal,
        finalTotal: (subtotal - (formData.discount || 0)) + vatAmount,
        status: formData.status === "Paid" ? "Paid" : dbStatus 
      });
      setIsSaving(false);
      return response.data;
    } catch (err) {
      setIsSaving(false);
      alert("Database error.");
      return null;
    }
  };

  const handleSaveDraft = async () => {
    const result = await saveToDatabase('draft');
    if (result) alert("Draft saved successfully!");
    // Reload the page after a tiny delay to ensure download starts
  setTimeout(() => {
    window.location.reload();
  }, 100);
};

  const generateAndDownloadPDF = async () => {
    // REMOVED: const result = await saveToDatabase('completed');
    // REMOVED: if (!result) return;

    const element = invoiceRef.current;
    
    // Using a higher scale for crisp text in the PDF
    const canvas = await html2canvas(element, { 
      scale: 3, 
      useCORS: true,
      logging: false 
    });
    
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    
    // A4 dimensions are 210mm x 297mm
    pdf.addImage(imgData, 'PNG', 0, 0, 210, 297);
    pdf.save(`Invoice_${formData.invoiceNo}.pdf`);
  };


  const generateAndDownloadPDFsave = async () => {
    const result = await saveToDatabase('completed');
    if (!result) return;
    const element = invoiceRef.current;
    const canvas = await html2canvas(element, { scale: 3, useCORS: true });
    const pdf = new jsPDF('p', 'mm', 'a4');
    pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 210, 297);
    pdf.save(`Invoice_${formData.invoiceNo}.pdf`);
    // Reload the page after a tiny delay to ensure download starts
  setTimeout(() => {
    window.location.reload();
  }, 100);
};

  const downloadAsImage = async () => {
    const element = invoiceRef.current;
    const canvas = await html2canvas(element, { scale: 3, useCORS: true });
    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = `Invoice_${formData.invoiceNo}.png`;
    link.click();
  };

  const downloadAsImagesave = async () => {
    const result = await saveToDatabase('completed');
    if (!result) return;
    const element = invoiceRef.current;
    const canvas = await html2canvas(element, { scale: 3, useCORS: true });
    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = `Invoice_${formData.invoiceNo}.png`;
    link.click();// Reload the page after a tiny delay to ensure download starts
  setTimeout(() => {
    window.location.reload();
  }, 100);
};

  const currentBalance = (subtotal - (formData.discount || 0) + vatAmount - totalPaid);
  
  const TotalBalance = (subtotal - (formData.discount || 0) + vatAmount);

  return (
  <div style={{ display: 'flex', height: '100vh', backgroundColor: '#f0f2f5', fontFamily: '"Inter", "Segoe UI", sans-serif' }}>
    
    {/* EDITOR PANEL - Kept as requested */}
    <div style={{ width: '600px', padding: '25px', overflowY: 'auto', background: '#fff', borderRight: '1px solid #e0e0e0', boxShadow: '2px 0 5px rgba(0,0,0,0.05)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h2 style={{ fontSize: '20px', margin: 0, color: '#2c3e50' }}>Customizer</h2>
      </div>

      <div style={{ 
        padding: '10px', textAlign: 'center', borderRadius: '6px', fontWeight: 'bold', fontSize: '12px', marginBottom: '20px',
        backgroundColor: formData.status === "Paid" ? '#d1fae5' : '#fee2e2',
        color: formData.status === "Paid" ? '#065f46' : '#991b1b',
        border: `1px solid ${formData.status === "Paid" ? '#10b981' : '#f87171'}`
      }}>
        STATUS: {formData.status.toUpperCase()}
      </div>

      <section style={{ marginBottom: '20px' }}>
        <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Company Logo</label>
        <input type="file" onChange={handleLogoUpload} style={{ display: 'block', marginTop: '8px', fontSize: '12px' }} />
      </section>

      <section style={{ marginBottom: '15px' }}>
        <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Currency</label>
        <select value={formData.currency} onChange={handleCurrencyChange} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #dcdde1' }}>
          <option value="BDT">Bangladeshi Taka (TK)</option>
          <option value="USD">US Dollar ($)</option>
          <option value="GBP">British Pound (£)</option>
          <option value="EUR">Euro (€)</option>
        </select>
      </section>

      {/* Director Details: Name and Title in a grid */}
<section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '15px' }}>
  <div>
    <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Invoice #</label>
    <input name="invoiceNo" value={formData.invoiceNo} onChange={handleInputChange} style={{ width: '100%', padding: '8px', border: '1px solid #dcdde1', borderRadius: '4px' }} readOnly/>
  </div>
</section>
<section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '15px' }}>
  <div>
    <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Issue Date</label>
    <input 
      type="date"
      name="issueDate" 
      value={formData.issueDate} 
      onChange={handleInputChange} 
      style={{ width: '100%', padding: '8px', border: '1px solid #dcdde1', borderRadius: '4px', fontSize: '12px' }} 
    />
  </div>
  <div>
    <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Due Date</label>
    <input 
      type="date"
      name="dueDate" 
      value={formData.dueDate} 
      onChange={handleInputChange} 
      style={{ width: '100%', padding: '8px', border: '1px solid #dcdde1', borderRadius: '4px', fontSize: '12px' }} 
    />
  </div>
</section>

      <section style={{ marginBottom: '15px' }}>
        <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Client Name:</label>       
        <input name="clientName" placeholder="Client Name" value={formData.clientName} onChange={handleInputChange} style={{ width: '100%', padding: '8px', marginBottom: '6px', border: '1px solid #dcdde1', borderRadius: '4px' }} />
        <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Client Company Name:</label>
        <input name="company" placeholder="Company Name" value={formData.company} onChange={handleInputChange} style={{ width: '100%', padding: '8px', marginBottom: '6px', border: '1px solid #dcdde1', borderRadius: '4px' }} />
        <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Client Address or Client Company Address:</label>
        <textarea name="address" placeholder="Address" value={formData.address} onChange={handleInputChange} style={{ width: '100%', padding: '8px', height: '60px', border: '1px solid #dcdde1', borderRadius: '4px', resize: 'none' }} />
      </section>

      <h4 style={{ fontSize: '14px', marginBottom: '10px', color: '#34495e', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Items</h4>
      {formData.items.map((item, i) => (
        <div key={i} style={{ display: 'flex', gap: '5px', marginBottom: '8px' }}>
          <input placeholder="Desc" style={{ flex: 2, padding: '8px', border: '1px solid #dcdde1', borderRadius: '4px' }} value={item.desc} onChange={(e) => handleItemChange(i, 'desc', e.target.value)} />
          <input type="number" placeholder="Rate" style={{ flex: 1, padding: '8px', border: '1px solid #dcdde1', borderRadius: '4px' }} value={item.rate} onChange={(e) => handleItemChange(i, 'rate', e.target.value)} />
          <input type="number" placeholder="Qty" style={{ width: '50px', padding: '8px', border: '1px solid #dcdde1', borderRadius: '4px' }} value={item.qty} onChange={(e) => handleItemChange(i, 'qty', e.target.value)} />
          <button onClick={() => removeItem(i)} style={{ background: '#f5f6fa', border: '1px solid #dcdde1', cursor: 'pointer', borderRadius: '4px' }}>×</button>
        </div>
      ))}
      <button onClick={addItem} style={{ width: '100%', padding: '8px', fontSize: '12px', cursor: 'pointer', marginBottom: '20px', background: '#f5f6fa', border: '1px dashed #7f8c8d' }}>+ Add Row</button>

      <h4 style={{ fontSize: '14px', marginBottom: '10px', color: '#34495e', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Client Transactions or Recent Payments</h4>
      {formData.transactions.map((t, i) => (
        <div key={i} style={{ background: '#fcfcfc', padding: '12px', marginBottom: '10px', border: '1px solid #eee', borderRadius: '6px' }}>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
        <label style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Payment Date</label>
            <input type="date" style={{ flex: 1.5, padding: '6px' }} value={t.date} onChange={(e) => handleTxChange(i, 'date', e.target.value)} />
        <label style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Paid Amount</label>
            <input type="number" placeholder="Amount" style={{ flex: 1, padding: '6px' }} value={t.amount} onChange={(e) => handleTxChange(i, 'amount', e.target.value)} />
            <button onClick={() => removeTransaction(i)} style={{ background: '#fee2e2', border: 'none', cursor: 'pointer', padding: '0 10px', borderRadius: '4px' }}>×</button>
          </div>
        <label style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Details of payment method</label>
          <input placeholder="Bank Check / Bank Transfer / bKash" style={{ width: '100%', padding: '6px', fontSize: '12px' }} value={t.method} onChange={(e) => handleTxChange(i, 'method', e.target.value)} />
        </div>
      ))}
      <button onClick={addTransaction} style={{ width: '100%', padding: '8px', fontSize: '12px', cursor: 'pointer', background: '#f5f6fa', border: '1px dashed #7f8c8d' }}>+ Add Payment</button>

  <section style={{ marginTop: '20px', borderTop: '2px solid #f5f6fa', paddingTop: '15px' }}>
  {/* Membership Selection */}
  <div style={{ marginBottom: '12px' }}>
    <label style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d', display: 'block', marginBottom: '5px' }}>
      Membership Type
    </label>
    <select 
      value={formData.membershipType} 
      onChange={handleMembershipChange} 
      style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
    >
      <option value="None">No Discount</option>
      <option value="Classic Membership">Classic Membership Discount</option>
      <option value="Signature Membership">Signature Membership Discount</option>
      <option value="Platinum Silver Membership">Platinum Silver Membership Discount</option>
      <option value="Platinum Gold Membership">Platinum Gold Membership Discount</option>
      <option value="Platinum Titanium Membership">Platinum Titanium Membership Discount</option>
    </select>
  </div>

  {/* Discount Amount */}
  <div style={{ marginBottom: '12px' }}>
    <label style={{ fontSize: '11px', fontWeight: '700', color: '#7f8c8d', display: 'block', marginBottom: '5px' }}>
      Discount Amount
    </label>
    <input 
      type="number" 
      name="discount" 
      value={formData.discount} 
      onChange={handleInputChange} 
      style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} 
    />
  </div>

  {/* VAT Rate */}
  <div>
    <label style={{ fontSize: '11px', fontWeight: '700', color: '#7f8c8d', display: 'block', marginBottom: '5px' }}>
      Valu Added Tax (VAT) in Percentage (%)
    </label>
    <input 
      type="number" 
      name="vatRate" 
      value={formData.vatRate} 
      onChange={handleInputChange} 
      style={{ width: '100%', padding: '8px', marginBottom: '20px', borderRadius: '4px', border: '1px solid #ccc' }} 
    />
  </div>
</section>

<section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px',  marginBottom: '20px' }}>
  <div>
    <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Signatory's Name</label>
    <input name="directorName" value={formData.directorName} onChange={handleInputChange} style={{ width: '100%', padding: '8px', border: '1px solid #dcdde1', borderRadius: '4px' }} />
  </div>
  <div>
    <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Signatory's Designation</label>
    <input name="directorTitle" value={formData.directorTitle} onChange={handleInputChange} style={{ width: '100%', padding: '8px', border: '1px solid #dcdde1', borderRadius: '4px' }} />
  </div>
  <div>
    <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#7f8c8d' }}>Upload Signatory's Signature Image</label>
    <input 
      type="file" 
      accept="image/*"
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => setFormData({ ...formData, signature: reader.result });
          reader.readAsDataURL(file);
        }
      }} 
      style={{ width: '100%', fontSize: '10px', marginBottom: '10px', marginTop: '5px' }} 
    />
  </div>
</section>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '25px' }}>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button disabled={isSaving} onClick={generateAndDownloadPDF} style={{ flex: 1, padding: '14px', background: '#ff5a07', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Generate PDF Only</button>
          <button onClick={downloadAsImage} style={{ flex: 1, padding: '14px', background: '#04c0ff', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Generate IMAGE Only</button>
        </div>
          <button disabled={isSaving} onClick={generateAndDownloadPDFsave} style={{ flex: 1, padding: '14px', background: '#5600f7', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Generate PDF and Save to Database</button>
          <button onClick={downloadAsImagesave} style={{ flex: 1, padding: '14px', background: '#007c6a', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Generate IMAGE and Save to Database</button>
        <button disabled={isSaving} onClick={handleSaveDraft} style={{ padding: '14px', background: '#00264c', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Save to Database Only</button>
        </div>
      </div>

    {/* REDESIGNED PREVIEW PANEL WITH SMALLER FONTS */}
<div style={{ flex: 1, padding: '40px', background: '#576574', display: 'flex', justifyContent: 'center', overflowY: 'auto' }}>
  <div ref={invoiceRef} style={{ width: '210mm', minHeight: '297mm', background: '#fff', padding: '0', boxSizing: 'border-box', position: 'relative', color: '#2c3e50', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
    
    {/* Header Branding Area */}
    <div style={{ display: 'flex', background: '#f8f5fe', color: '#160E44', padding: '30px 10mm' }}>
      <div style={{ flex: 2 }}>
        {logo ? (
  <img src={logo} alt="Uploaded Logo" style={{ maxHeight: '60px' }} />
) : (
  <img src={defaultLogo} alt="Default Logo" style={{ maxHeight: '60px' }} />
)}
        <p style={{ margin: '8px 0 0 0', opacity: 0.8, fontSize: '8.5pt', maxWidth: '280px', lineHeight: '1.4', padding: '0px 10mm' }}>Professional Business Solutions & Digital Services</p>
      </div>
      <div style={{ flex: 1, textAlign: 'right' }}>
        <h1 style={{ fontSize: '16pt', margin: 0, fontWeight: '800', letterSpacing: '-1px', color: '#662d91' }}>INVOICE</h1>
        <p style={{ margin: 0, fontSize: '10pt', fontWeight: '600', color: '#295d80' }}>Invoice No. {formData.invoiceNo}</p>
      </div>
    </div>

    {/* Info Grid */}
    <div style={{ padding: '15mm 20mm' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '30px', marginBottom: '35px' }}>
        <div>
          <h4 style={{ textTransform: 'uppercase', fontSize: '8pt', color: '#7f8c8d', letterSpacing: '1px', marginBottom: '10px' }}>Billed to:</h4>          
          <h5 style={{ margin: '2px 0 6px 0', fontSize: '10pt', fontWeight: '800', color: '#34495e' }}>Client Name: <h6 style={{ margin: '2px 0 6px 0', fontSize: '10pt', fontWeight: '700', color: '#5900ff' }}>{formData.clientName}</h6></h5>          
          <h5 style={{ margin: '2px 0 6px 0', fontSize: '10pt', lineHeight: '2.5', fontWeight: '800', color: '#34495e' }}>Company Name: <h6 style={{ margin: '2px 0 6px 0', fontSize: '10pt', lineHeight: '0.5', fontWeight: '700', color: '#5900ff' }}>{formData.company}</h6></h5>
          <p style={{ margin: 0, color: '#7f8c8d', fontSize: '9pt', lineHeight: '1.5', width: '280px', fontWeight: '500', }}>{formData.address}</p>
        </div>
        
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', background: '#f8f9fa', padding: '15px', borderRadius: '6px', alignSelf: 'start' }}>
          <div>
            <h4 style={{ margin: '0 0 4px 0', fontSize: '7pt', color: '#7f8c8d', textTransform: 'uppercase' }}>Date Issued</h4>
            <p style={{ margin: 0, fontSize: '9pt', fontWeight: '700' }}>{formData.issueDate.split('-').reverse().join('/')}</p>
          </div>
          <div>
            <h4 style={{ margin: '0 0 4px 0', fontSize: '7pt', color: '#7f8c8d', textTransform: 'uppercase' }}>Due Date</h4>
            <p style={{ margin: 0, fontSize: '9pt', fontWeight: '700', color: '#e74c3c' }}>{formData.dueDate.split('-').reverse().join('/')}</p>
          </div>
        </div>
      </div>

      {/* Styled Items Table */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '25px' }}>
        <thead>
          <tr style={{ background: '#f8f9fa' }}>
            <th style={{ padding: '12px 15px', textAlign: 'left', fontSize: '8pt', textTransform: 'uppercase', color: '#2c3e50', borderBottom: '2px solid #2c3e50' }}>Description</th>
            <th style={{ padding: '12px 15px', textAlign: 'right', fontSize: '8pt', textTransform: 'uppercase', color: '#2c3e50', borderBottom: '2px solid #2c3e50' }}>Rate</th>
            <th style={{ padding: '12px 15px', textAlign: 'center', fontSize: '8pt', textTransform: 'uppercase', color: '#2c3e50', borderBottom: '2px solid #2c3e50' }}>Qty</th>
            <th style={{ padding: '12px 15px', textAlign: 'right', fontSize: '8pt', textTransform: 'uppercase', color: '#2c3e50', borderBottom: '2px solid #2c3e50' }}>Subtotal</th>
          </tr>
        </thead>
        <tbody>
          {formData.items.map((item, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 15px', fontSize: '9.5pt', fontWeight: '600' }}>{item.desc}</td>
              <td style={{ padding: '12px 15px', textAlign: 'right', fontSize: '9pt', color: '#7f8c8d' }}>{formData.currencySymbol}&nbsp;{item.rate.toLocaleString()}/-</td>
              <td style={{ padding: '12px 15px', textAlign: 'center', fontSize: '9pt' }}>{item.qty}</td>
              <td style={{ padding: '12px 15px', textAlign: 'right', fontSize: '9.5pt', fontWeight: '700' }}>{formData.currencySymbol}&nbsp;{(item.rate * item.qty).toLocaleString()}/-</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals & Payments Section */}
      <div style={{ display: 'flex', gap: '30px' }}>
        <div style={{ flex: 1.2 }}>
          <h4 style={{ fontSize: '8pt', textTransform: 'uppercase', color: '#7f8c8d', marginBottom: '8px' }}>Recent Payments</h4>
          {formData.transactions.map((t, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', background: '#fcfcfc', border: '1px solid #eee', borderRadius: '4px', marginBottom: '4px' }}>
              <span style={{ fontSize: '8pt' }}>{t.date.split('-').reverse().join('/')} • {t.method}</span>
              <span style={{ marginLeft:'8pt', fontSize: '8pt', fontWeight: '700' }}>{formData.currencySymbol}&nbsp;{t.amount.toLocaleString()}/-</span>
            </div>
          ))}
          <div style={{ marginTop: '12px', padding: '8px 12px', borderRadius: '4px', borderLeft: '3px solid #3498db', background: '#ebf5fb' }}>
            <p style={{ margin: 0, fontSize: '8pt', color: '#2980b9', fontStyle: 'italic', lineHeight: '1.4' }}>{formData.paidStatus}</p>
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
            <span style={{ color: '#7f8c8d', fontSize: '9pt', fontWeight: '600' }}>Total</span>
            <span style={{ fontWeight: '600', fontSize: '9pt' }}>{formData.currencySymbol}&nbsp;{subtotal.toLocaleString()}/-</span>
          </div>
          {formData.discount > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', color: '#e74c3c' }}>
              <span style={{ fontSize: '9pt', fontWeight: '600' }}>Discount ({formData.membershipType})</span>
              <span style={{ fontWeight: '600', fontSize: '9pt' }}>-{formData.currencySymbol}&nbsp;{formData.discount.toLocaleString()}/-</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ color: '#7f8c8d', fontSize: '9pt', fontWeight: '600' }}>VAT ({formData.vatRate}%)</span>
            <span style={{ fontWeight: '600', fontSize: '9pt' }}>{formData.currencySymbol}&nbsp;{vatAmount.toLocaleString()}/-</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '10pt', fontWeight: '900', textTransform: 'uppercase' }}>Grand Total:</span>
            <span style={{ fontSize: '12pt', fontWeight: '900', color: '#2c3e50' }}>{formData.currencySymbol}&nbsp;{TotalBalance.toLocaleString()}/-</span>
          </div>{/* Conditional Balance Due or Paid Seal */}
{/* DYNAMIC SETTLEMENT SECTION */}
<div style={{ 
  marginTop: '25px', 
  padding: '20px', 
  background: currentBalance <= 0 ? '#f8fafc' : 'transparent', 
  borderRadius: '8px',
  position: 'relative',
  overflow: 'hidden' // Clips the watermark
}}>
  
  {/* Dynamic Watermark Background (Only shows when paid) */}
  {currentBalance <= 0 && (
    <div style={{
      position: 'absolute',
      right: '-10px',
      bottom: '-10px',
      fontSize: '80pt',
      fontWeight: '900',
      color: '#10b981',
      opacity: 0.05,
      pointerEvents: 'none',
      transform: 'rotate(-15deg)',
      userSelect: 'none'
    }}>
      PAID
    </div>
  )}

  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', position: 'relative', zIndex: 1 }}>
    
    {/* Left Side: Status & Details */}
    <div>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px', 
        marginBottom: '4px' 
      }}>
        <div style={{ 
          width: '8px', 
          height: '8px', 
          borderRadius: '50%', 
          background: currentBalance <= 0 ? '#10b981' : '#ef4444',
          boxShadow: currentBalance <= 0 ? '0 0 8px #10b981' : 'none' 
        }}></div>
        <span style={{ 
          fontSize: '9pt', 
          fontWeight: '800', 
          textTransform: 'uppercase', 
          letterSpacing: '1px',
          color: currentBalance <= 0 ? '#065f46' : '#991b1b' 
        }}>
          {currentBalance <= 0 ? 'Transaction Settled' : 'Payment Outstanding'}
        </span>
      </div>
      
      {currentBalance <= 0 ? (
        <p style={{ margin: 0, fontSize: '8pt', color: '#64748b', maxWidth: '240px' }}>
          Payment received in full. Thank you for your payments.
        </p>
      ) : (
        <p style={{ margin: 0, fontSize: '8pt', color: '#64748b' }}>
          Please clear all the payments by <strong>{formData.dueDate.split('-').reverse().join('/')}</strong>.
        </p>
      )}
    </div>

    {/* Right Side: Financial Calculation */}
    <div style={{ textAlign: 'right' }}>
      <p style={{ 
        margin: 0, 
        fontSize: '8pt', 
        color: '#94a3b8', 
        textTransform: 'uppercase', 
        fontWeight: '700' 
      }}>
        {currentBalance <= 0 ? 'Total Paid Amount' : 'Net Amount Due'}
      </p>
      
      <div style={{ 
        fontSize: '22pt', 
        fontWeight: '900', 
        letterSpacing: '-0.5px',
        color: currentBalance <= 0 ? '#065f46' : '#991b1b',
        lineHeight: '1.1'
      }}>
        <span style={{ fontSize: '14pt', verticalAlign: 'middle', marginRight: '2px' }}>
          {formData.currencySymbol}
        </span>
        {(currentBalance <= 0 
          ? (subtotal - (formData.discount || 0) + vatAmount) 
          : currentBalance
        ).toLocaleString()}
        <span style={{ fontSize: '14pt', verticalAlign: 'middle' }}>/-</span>
      </div>

      {currentBalance <= 0 && (
        <div style={{ 
          marginTop: '4px',
          display: 'inline-block',
          padding: '2px 8px',
          background: '#10b981',
          color: '#fff',
          fontSize: '7pt',
          fontWeight: '900',
          borderRadius: '2px',
          textTransform: 'uppercase'
        }}>
          Balance TK 0.00
        </div>
      )}
    </div>
  </div>
</div>

{/* Total Received Summary (Optional, only shows when paid) */}
{currentBalance <= 0 && (
  <div style={{ textAlign: 'right', borderTop: '1px solid #eee', paddingTop: '10px' }}>
    <span style={{ fontSize: '9pt', color: '#7f8c8d' }}>Total Received: </span>
    <span style={{ fontSize: '11pt', fontWeight: '700', color: '#27ae60' }}>
      {formData.currencySymbol}{(subtotal - (formData.discount || 0) + vatAmount).toLocaleString()}/-
    </span>
  </div>
)}
        </div>
      </div>

      {/* FIXED SIGNATURE SECTION - Anchored above the footer bar */}
<div style={{ 
  position: 'absolute', 
  bottom: '120px', // Adjust this to sit right above the contact row
  left: '20mm', 
  right: '20mm',
  display: 'flex', 
  justifyContent: 'space-between', 
  alignItems: 'flex-end' 
}}>
  <div>
    <p style={{ margin: '0 0 10px 0', fontSize: '8pt', color: '#7f8c8d', textTransform: 'uppercase' }}>Issued By</p>
    
    {/* Digital Signature Container */}
    <div style={{ height: '50px', display: 'flex', alignItems: 'flex-end', marginBottom: '5px' }}>
      {formData.signature && (
        <img 
          src={formData.signature} 
          alt="Signature" 
          style={{ maxHeight: '30px', maxWidth: '180px', objectFit: 'contain' }} 
        />
      )}
    </div>

    <div style={{ borderBottom: '1.4px solid #2c3e50', width: '120px', marginBottom: '6px' }}></div>
    <p style={{ margin: 0, fontSize: '10pt', fontWeight: '900', color: '#1e1b4b' }}>{formData.directorName}</p>
    <p style={{ margin: 0, fontSize: '8.5pt', fontWeight: '600', color: 'rgb(0, 68, 255)' }}><i>{formData.directorTitle}</i></p>
    <p style={{ margin: 0, fontSize: '8.5pt', color: '#5900ff', fontWeight: '900' }}>{formData.companyTitle}</p>
  </div>

  <div style={{ textAlign: 'right', fontSize: '7.5pt', color: '#bdc3c7', lineHeight: '1.4' }}>
    <p style={{ margin: 0 }}>This is a computer-generated document.</p>
    <p style={{ margin: 0 }}>Thank you for your business!</p>
  </div>
</div>

{/* FIXED BRANDED FOOTER BAR - Anchored to absolute bottom */}
<div style={{ 
  position: 'absolute', 
  bottom: 0, 
  left: 0, 
  width: '100%', 
  backgroundColor: '#fff' 
}}>
        {/* Contact Row */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '30px', 
          padding: '10px 0', 
          fontSize: '9pt', 
          fontWeight: '800', 
          color: '#000' 
        }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ color: '#e91e63', fontSize: '10pt' }}>📞</span> +8801783509033
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ color: '#9c27b0', fontSize: '10pt' }}>✉️</span> info@auroracreativesbd.com
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ color: '#03a9f4', fontSize: '10pt' }}>🌐</span> www.auroracreativesbd.com
          </span>
        </div>

        {/* Branded Gradient Bar */}
        <div style={{ 
        background: 'linear-gradient(90deg, #2e1065 0%, #6200ff 35%, #7c3aed 70%, #994ae8 100%)',
        padding: '18px 24px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        color: '#ffffff'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
    {/* Dynamic Logo from Upload */}
    {logo ? (
      <img 
        src={logo} 
        alt="Footer Logo" 
        style={{ 
          height: '25px', 
          maxWidth: '200px', 
          objectFit: 'contain' // Forces the logo to be pure white
        }} 
      />
    ) : (
      <img 
        src={fLogo} 
        alt="Footer Logo" 
        style={{ 
          height: '25px', 
          maxWidth: '200px', 
          objectFit: 'contain' 
        }} 
      />
    )}

    <div style={{ height: '16px', width: '1px', background: 'rgba(255,255,255,0.4)' }}></div>
    <span style={{ fontSize: '7.5pt', fontWeight: '500', letterSpacing: '0.8px', opacity: 0.9 }}>
      Crafting visual experiences where every pixel tells a story
    </span>
  </div>
          
          <div style={{ fontSize: '7.5pt', textAlign: 'right', maxWidth: '900px', lineHeight: '1.4' }}>
            <span style={{ fontWeight: '700' }}>Address:</span> Shahjalal Avenue, Azampur Uttara, Dhaka - 1230, Bangladesh.
          </div>
        </div>
      </div>
  </div>
</div>
  </div>
  </div>
);
};

export default NewInvoice;